module.exports = __webpack_public_path__ + "img/b3625935edff4a4f877da8e1e2044a53.b0d4b8bf.jpg";